/* import __COLOCATED_TEMPLATE__ from './address-input-field-sorting-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldSorting from './address-input-field-sorting';
let AddressInputFieldSortingOld = (_dec = tagName(''), _dec(_class = class AddressInputFieldSortingOld extends AddressInputFieldSorting {}) || _class);
export { AddressInputFieldSortingOld as default };